import { ERouteHttpVerb } from "@devowl-wp/api";
const routeLocationPaddleCheckoutPatch = {
    path: "/paddle/checkout",
    method: ERouteHttpVerb.PATCH
};
export { routeLocationPaddleCheckoutPatch };
